import { NAME } from './fields'

export const transformValuesToBE = values => {
  return {
    [NAME]: values[NAME]
  }
}
